"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._downloadTemplateProduction = exports._uploadProcessProduction = exports._uploadDocumentProduction = exports._getGridHistoryProduction = exports._getGridProduction = void 0;
const qs_1 = __importDefault(require("qs"));
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("utils/constants");
const error_response_1 = require("utils/error-response");
const getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
const _getGridProduction = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify({
        filters: filter.filters.map(item => {
            if (item.field === 'contractor' || item.field === 'brand' ||
                item.field === 'area' || item.field === 'year') {
                return item;
            }
            else {
                return {
                    field: item.field,
                    operator: 'eq',
                    value: parseInt(item.value)
                };
            }
        }),
        logic: filter.logic
    }) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/production';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError, errorCode, errorMessage, data: [], countData: 0, totalOnMonth: defaultTarget
        };
    }
});
exports._getGridProduction = _getGridProduction;
const _getGridHistoryProduction = ({ skip, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/production-log';
    const config = {
        params: { skip, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridHistoryProduction = _getGridHistoryProduction;
const _uploadDocumentProduction = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/upload-file';
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.post(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, name: '', countData: 0 };
    }
});
exports._uploadDocumentProduction = _uploadDocumentProduction;
const _uploadProcessProduction = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/production-upload';
    const data = qs_1.default.stringify(payload);
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token(),
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    };
    try {
        const response = yield axios_1.default.post(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, message: '', countData: 0 };
    }
});
exports._uploadProcessProduction = _uploadProcessProduction;
const _downloadTemplateProduction = ({ year }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/download-template';
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    if (year)
        config.params = { year };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, url: '', countData: 0 };
    }
});
exports._downloadTemplateProduction = _downloadTemplateProduction;
const defaultTarget = {
    id: '',
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dec: 0,
    area: '',
    brand: '',
    year: '',
    contractor: '',
    created_by: '',
    modified_by: '',
    created_date: new Date(),
    modified_date: new Date(),
};
